import { TratamentoMadeiraItemContainer } from "app/components/madeira/TratamentoMadeiraItemContainer"
import { renderizarComponentReact } from "app/components/renderizarOuRemoverComponentReact"
import store from "app/redux/store/store"
import * as R from "ramda"
import React from "react"

export async function preencherDadosTratamentoMadeira() {
    const itensMadeira = store.getState().orcamento.ItensOrcamento.filter(i => i.Madeira && i.DadosMadeira == null)
    const chamarTratamentoMadeira = (item, itensRestantes) => {
        const nextItem = R.head(itensRestantes)
        return nextItem ? <TratamentoMadeiraItemContainer
            item={item}
            somenteLeitura={false}
            onOk={() => renderizarComponentReact(chamarTratamentoMadeira(nextItem,R.tail(itensRestantes)),"conteudo-pagina",false)}
            onClose={() => renderizarComponentReact(chamarTratamentoMadeira(nextItem,R.tail(itensRestantes)),"conteudo-pagina",false)}
        /> : <TratamentoMadeiraItemContainer
            item={item}
            somenteLeitura={false}
            onOk={() => null}
            onClose={() => null} />
    }

    itensMadeira.length > 0 && renderizarComponentReact(
        chamarTratamentoMadeira(
            R.head(itensMadeira),
            R.tail(itensMadeira)
        ),"conteudo-pagina",false)
}
